import { twMerge } from 'tailwind-merge';

import { Skeleton } from '../progress';

export function InputSkeleton({ className, noLabel = false }: { className?: string; noLabel?: boolean }) {
  return (
    <div className={twMerge('relative flex h-16.5 flex-col pt-1.5', className)}>
      {!noLabel && <Skeleton className="absolute -top-2.5 mt-0.5 w-28 max-w-[80%]" />}
      <Skeleton className="flex-1" />
      <div className="mt-1.5 h-4 w-full" />
    </div>
  );
}
